import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { Slide, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';

import 'dayjs/locale/ja';

import AssessmentLayout from 'layouts/AssessmentLayout';
import ContractLayout from 'layouts/ContractLayout';
import DevDocsLayout from 'layouts/DevDocsLayout';
import ExpenseLayout from 'layouts/ExpenseLayout';
import GuideLayout from 'layouts/GuideLayout';
import IndexLayout from 'layouts/IndexLayout';
import ManagementLayout from 'layouts/ManagementLayout';
import MemberLayout from 'layouts/MemberLayout';
import SecurityLayout from 'layouts/SecurityLayout';
import TicketLayout from 'layouts/TicketLayout';
import TrainingAdminLayout from 'layouts/TrainingAdminLayout';
import TrainingLearnLayout from 'layouts/TrainingLearnLayout';
import WorkspaceLayout from 'layouts/WorkspaceLayout';
import Home from 'pages/Home';
import Login from 'pages/Login';
import AssessmentManagement from 'pages/assessment/AssessmentManagement';
import AssessmentHome from 'pages/assessment/Home';
import ChecklistManagement from 'pages/contract/ChecklistManagement';
import ContractManagement from 'pages/contract/ContractManagement';
import ContractRequestCreate from 'pages/contract/ContractRequestCreate';
import ContractRequestManagement from 'pages/contract/ContractRequestManagement';
import ContractHome from 'pages/contract/Home';
import PasteDefinitionManagement from 'pages/contract/PasteDefinitionManagement';
import TemplateManagement from 'pages/contract/TemplateManagement';
import DevDocsHome from 'pages/devdocs/Home';
import ProductivityAnalysis from 'pages/devdocs/ProductivityAnalysis';
import ThoughtsAi from 'pages/devdocs/ThoughtsAi';
import ArticleDetail from 'pages/devdocs/article/ArticleDetail';
import ArticleForm from 'pages/devdocs/article/ArticleForm';
import HandsonApiSpecs from 'pages/devdocs/workflow/HandsonApiSpecs';
import HandsonApiWorkflow from 'pages/devdocs/workflow/HandsonApiWorkflow';
import HandsonE2e from 'pages/devdocs/workflow/HandsonE2e';
import HandsonHome from 'pages/devdocs/workflow/HandsonHome';
import HandsonImplementation from 'pages/devdocs/workflow/HandsonImplementation';
import HandsonPreparation from 'pages/devdocs/workflow/HandsonPreparation';
import HandsonProduct from 'pages/devdocs/workflow/HandsonProduct';
import HandsonProjectSetup from 'pages/devdocs/workflow/HandsonProjectSetup';
import HandsonProposalBusiness from 'pages/devdocs/workflow/HandsonProposalBusiness';
import HandsonRfp from 'pages/devdocs/workflow/HandsonRfp';
import HandsonSchemaApi from 'pages/devdocs/workflow/HandsonSchemaApi';
import HandsonScreenIo from 'pages/devdocs/workflow/HandsonScreenIo';
import HandsonSteeringRules from 'pages/devdocs/workflow/HandsonSteeringRules';
import HandsonStoryScaffold from 'pages/devdocs/workflow/HandsonStoryScaffold';
import HandsonStructureTech from 'pages/devdocs/workflow/HandsonStructureTech';
import HandsonUsecase from 'pages/devdocs/workflow/HandsonUsecase';
import WorkflowBeAppendix from 'pages/devdocs/workflow/WorkflowBeAppendix';
import WorkflowBeStep1 from 'pages/devdocs/workflow/WorkflowBeStep1';
import WorkflowBeStep2 from 'pages/devdocs/workflow/WorkflowBeStep2';
import WorkflowBeStep3 from 'pages/devdocs/workflow/WorkflowBeStep3';
import WorkflowBeStep4 from 'pages/devdocs/workflow/WorkflowBeStep4';
import WorkflowBeStep5 from 'pages/devdocs/workflow/WorkflowBeStep5';
import WorkflowBeStep6 from 'pages/devdocs/workflow/WorkflowBeStep6';
import WorkflowHome from 'pages/devdocs/workflow/WorkflowHome';
import WorkflowKiroBasics1 from 'pages/devdocs/workflow/WorkflowKiroBasics1';
import WorkflowKiroBasics2 from 'pages/devdocs/workflow/WorkflowKiroBasics2';
import WorkflowKiroBasics3 from 'pages/devdocs/workflow/WorkflowKiroBasics3';
import WorkflowKiroBasics4 from 'pages/devdocs/workflow/WorkflowKiroBasics4';
import WorkflowReqStep1 from 'pages/devdocs/workflow/WorkflowReqStep1';
import WorkflowReqStep2 from 'pages/devdocs/workflow/WorkflowReqStep2';
import WorkflowReqStep3 from 'pages/devdocs/workflow/WorkflowReqStep3';
import WorkflowReqStep4 from 'pages/devdocs/workflow/WorkflowReqStep4';
import NotFound from 'pages/error/NotFound';
import NotImplemented from 'pages/error/NotImplemented';
import ExpenseDashboard from 'pages/expense/Dashboard';
import ExpenseManagement from 'pages/expense/Expense';
import ExpenseHome from 'pages/expense/Home';
import ExpenseLabelManagement from 'pages/expense/Label';
import ExpenseStoreManagement from 'pages/expense/Store';
import GuideHome from 'pages/guide/Home';
import GuideAssessmentBulkRegister from 'pages/guide/assessment/GuideAssessmentBulkRegister';
import GuideAssessmentDetail from 'pages/guide/assessment/GuideAssessmentDetail';
import GuideAssessmentDispose from 'pages/guide/assessment/GuideAssessmentDispose';
import GuideAssessmentOverview from 'pages/guide/assessment/GuideAssessmentOverview';
import GuideAssessmentRegister from 'pages/guide/assessment/GuideAssessmentRegister';
import GuideAssessmentSearch from 'pages/guide/assessment/GuideAssessmentSearch';
import GuideAssessmentUpdate from 'pages/guide/assessment/GuideAssessmentUpdate';
import GuideClientBulkRegister from 'pages/guide/client/GuideClientBulkRegister';
import GuideClientDetail from 'pages/guide/client/GuideClientDetail';
import GuideClientOverview from 'pages/guide/client/GuideClientOverview';
import GuideClientRegister from 'pages/guide/client/GuideClientRegister';
import GuideClientSearch from 'pages/guide/client/GuideClientSearch';
import GuideClientUpdate from 'pages/guide/client/GuideClientUpdate';
import GuideCommonOverview from 'pages/guide/common/GuideCommonOverview';
import GuideFeedback from 'pages/guide/common/GuideFeedback';
import GuideSearchCondition from 'pages/guide/common/GuideSearchCondition';
import GuideContractChangeTerminate from 'pages/guide/contract/GuideContractChangeTerminate';
import GuideContractChecklist from 'pages/guide/contract/GuideContractChecklist';
import GuideContractComment from 'pages/guide/contract/GuideContractComment';
import GuideContractDuplicate from 'pages/guide/contract/GuideContractDuplicate';
import GuideContractNewRequest from 'pages/guide/contract/GuideContractNewRequest';
import GuideContractOverview from 'pages/guide/contract/GuideContractOverview';
import GuideContractPastePage from 'pages/guide/contract/GuideContractPastePage';
import GuideContractRequestManage from 'pages/guide/contract/GuideContractRequestManage';
import GuideContractSearch from 'pages/guide/contract/GuideContractSearch';
import GuideContractTemplate from 'pages/guide/contract/GuideContractTemplate';
import GuideBackendDeploy from 'pages/guide/deploy/GuideBackendDeploy';
import GuideDeployOverview from 'pages/guide/deploy/GuideDeployOverview';
import GuideDeveloperDbAccess from 'pages/guide/deploy/GuideDeveloperDbAccess';
import GuideFrontendDeploy from 'pages/guide/deploy/GuideFrontendDeploy';
import GuideFinancialYear from 'pages/guide/financial-year/GuideFinancialYear';
import GuideFinancialYearOverview from 'pages/guide/financial-year/GuideFinancialYearOverview';
import GuideMemberBulkRegister from 'pages/guide/member/GuideMemberBulkRegister';
import GuideMemberDelete from 'pages/guide/member/GuideMemberDelete';
import GuideMemberDetail from 'pages/guide/member/GuideMemberDetail';
import GuideMemberOverview from 'pages/guide/member/GuideMemberOverview';
import GuideMemberRegisterEmployee from 'pages/guide/member/GuideMemberRegisterEmployee';
import GuideMemberRegisterExternal from 'pages/guide/member/GuideMemberRegisterExternal';
import GuideMemberSearch from 'pages/guide/member/GuideMemberSearch';
import GuideMemberUpdate from 'pages/guide/member/GuideMemberUpdate';
import GuideNoticeAdminManage from 'pages/guide/notice/GuideNoticeAdminManage';
import GuideNoticeCreateInfo from 'pages/guide/notice/GuideNoticeCreateInfo';
import GuideNoticeCreateNotice from 'pages/guide/notice/GuideNoticeCreateNotice';
import GuideNoticeOverview from 'pages/guide/notice/GuideNoticeOverview';
import GuideNoticeUser from 'pages/guide/notice/GuideNoticeUser';
import GuidePartnerBulkRegister from 'pages/guide/partner/GuidePartnerBulkRegister';
import GuidePartnerDetail from 'pages/guide/partner/GuidePartnerDetail';
import GuidePartnerOverview from 'pages/guide/partner/GuidePartnerOverview';
import GuidePartnerRegister from 'pages/guide/partner/GuidePartnerRegister';
import GuidePartnerSearch from 'pages/guide/partner/GuidePartnerSearch';
import GuidePartnerUpdate from 'pages/guide/partner/GuidePartnerUpdate';
import GuideProjectBulkRegister from 'pages/guide/project/GuideProjectBulkRegister';
import GuideProjectDetail from 'pages/guide/project/GuideProjectDetail';
import GuideProjectOverview from 'pages/guide/project/GuideProjectOverview';
import GuideProjectRegister from 'pages/guide/project/GuideProjectRegister';
import GuideProjectSearch from 'pages/guide/project/GuideProjectSearch';
import GuideProjectUpdate from 'pages/guide/project/GuideProjectUpdate';
import GuideSecurityAdmin from 'pages/guide/security/GuideSecurityAdmin';
import GuideSecurityOverview from 'pages/guide/security/GuideSecurityOverview';
import GuideSecurityUser from 'pages/guide/security/GuideSecurityUser';
import GuideTrainingAdmin from 'pages/guide/training/GuideTrainingAdmin';
import GuideTrainingExecute from 'pages/guide/training/GuideTrainingExecute';
import GuideTrainingOverview from 'pages/guide/training/GuideTrainingOverview';
import GuideTrainingWorkspace from 'pages/guide/training/GuideTrainingWorkspace';
import GuideUserDelete from 'pages/guide/user/GuideUserDelete';
import GuideUserOverview from 'pages/guide/user/GuideUserOverview';
import GuideUserRegister from 'pages/guide/user/GuideUserRegister';
import GuideUserRole from 'pages/guide/user/GuideUserRole';
import GuideUserSearch from 'pages/guide/user/GuideUserSearch';
import GuideUserUpdate from 'pages/guide/user/GuideUserUpdate';
import KnzReference from 'pages/knz/KnzReference';
import AdminNoticeImportant from 'pages/management/AdminNoticeImportant';
import AdminNoticeInfo from 'pages/management/AdminNoticeInfo';
import AdminNoticeNotice from 'pages/management/AdminNoticeNotice';
import FinancialYearManagement from 'pages/management/FinancialYearManagement';
import ManagementHome from 'pages/management/Home';
import UserManagement from 'pages/management/UserManagement';
import ClientManagement from 'pages/member/ClientManagement';
import MemberHome from 'pages/member/Home';
import MemberManagement from 'pages/member/MemberManagement';
import PartnerManagement from 'pages/member/PartnerManagement';
import ProjectManagement from 'pages/member/ProjectManagement';
import SecurityHome from 'pages/security/Home';
import SecurityCheckManagement from 'pages/security/SecurityCheckManagement';
import SecurityCheckPage from 'pages/security/SecurityCheckPage';
import GlobalTicketTypeSettings from 'pages/ticket/GlobalTicketTypeSettings';
import TicketHome from 'pages/ticket/Home';
import PrivateTicketTypeSettings from 'pages/ticket/PrivateTicketTypeSettings';
import TicketBoard from 'pages/ticket/TicketBoard';
import TicketGantt from 'pages/ticket/TicketGantt';
import TicketList from 'pages/ticket/TicketList';
import TrainingAdminAssignmentManagement from 'pages/training-admin/AssignmentManagement';
import TrainingAdminHome from 'pages/training-admin/Home';
import TrainingAdminProgressDashboard from 'pages/training-admin/ProgressDashboard';
import TrainingAdminQuestionManagement from 'pages/training-admin/QuestionManagement';
import TrainingLearnAllQuestions from 'pages/training-learn/AllQuestions';
import TrainingLearnAssignmentList from 'pages/training-learn/AssignmentList';
import TrainingLearnHome from 'pages/training-learn/Home';
import TrainingLearnQuestionDetail from 'pages/training-learn/QuestionDetail';
import TrainingLearnQuestionList from 'pages/training-learn/QuestionList';
import WorkspacePage from 'pages/workspace/WorkspacePage';
import AuthenticatedLayoutRoute from 'routes/AuthenticatedLayoutRoute';
import AuthenticatedRoute from 'routes/AuthenticatedRoute';
import OptionalAuthLayoutRoute from 'routes/OptionalAuthLayoutRoute';

function App() {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="ja">
      <BrowserRouter>
        <Routes>
          <Route path="/login" Component={Login} />
          {/* 認証は1回だけ行い、レイアウト切り替えはネストで実現 */}
          <Route path="/" element={<AuthenticatedRoute />}>
            <Route element={<AuthenticatedLayoutRoute layout={IndexLayout} />}>
              <Route index Component={Home} />
            </Route>
            <Route
              path="management"
              element={<AuthenticatedLayoutRoute layout={ManagementLayout} />}
            >
              <Route index Component={ManagementHome} />
              <Route path="user" Component={UserManagement} />
              <Route path="notice">
                <Route path="list" Component={AdminNoticeNotice} />
                <Route path="info" Component={AdminNoticeInfo} />
                <Route path="important" Component={AdminNoticeImportant} />
              </Route>
              <Route path="settings" Component={NotImplemented} />
              <Route path="financial-year" Component={FinancialYearManagement} />
              <Route path="*" Component={NotFound} />
            </Route>
            <Route path="member" element={<AuthenticatedLayoutRoute layout={MemberLayout} />}>
              <Route index Component={MemberHome} />
              <Route path="partner" Component={PartnerManagement} />
              <Route path="client" Component={ClientManagement} />
              <Route path="project" Component={ProjectManagement} />
              <Route path="project/:projectId" Component={ProjectManagement} />
              <Route path="member-mgmt" Component={MemberManagement} />
              <Route path="*" Component={NotFound} />
            </Route>
            <Route path="contract" element={<AuthenticatedLayoutRoute layout={ContractLayout} />}>
              <Route index Component={ContractHome} />
              <Route path="contract-list" Component={ContractManagement} />
              <Route path="request" Component={ContractRequestManagement} />
              <Route path="request/:contractRequestId" Component={ContractRequestManagement} />
              <Route path="contract-request-create" Component={ContractRequestCreate} />
              <Route path="checklist" Component={ChecklistManagement} />
              <Route path="template" Component={TemplateManagement} />
              <Route path="paste" Component={PasteDefinitionManagement} />
              <Route path="*" Component={NotFound} />
            </Route>
            <Route
              path="assessment"
              element={<AuthenticatedLayoutRoute layout={AssessmentLayout} />}
            >
              <Route index Component={AssessmentHome} />
              <Route path="assessment-management" Component={AssessmentManagement} />
              <Route path="assessment-management/:assessmentId" Component={AssessmentManagement} />
              <Route path="*" Component={NotFound} />
            </Route>
            <Route path="security" element={<AuthenticatedLayoutRoute layout={SecurityLayout} />}>
              <Route index Component={SecurityHome} />
              <Route path="security-check-management" Component={SecurityCheckManagement} />
              <Route path="security-check" Component={SecurityCheckPage} />
              <Route path="security-check/:resultId" Component={SecurityCheckPage} />
              <Route path="*" Component={NotFound} />
            </Route>
            <Route path="expense" element={<AuthenticatedLayoutRoute layout={ExpenseLayout} />}>
              <Route index Component={ExpenseHome} />
              <Route path="expense-dashboard" Component={ExpenseDashboard} />
              <Route path="expense-management" Component={ExpenseManagement} />
              <Route path="expense-label" Component={ExpenseLabelManagement} />
              <Route path="expense-store" Component={ExpenseStoreManagement} />
              <Route path="*" Component={NotFound} />
            </Route>
            <Route path="guide" element={<AuthenticatedLayoutRoute layout={GuideLayout} />}>
              <Route index Component={GuideHome} />
              {/* ユーザー管理 */}
              <Route path="user/overview" Component={GuideUserOverview} />
              <Route path="user/register" Component={GuideUserRegister} />
              <Route path="user/update" Component={GuideUserUpdate} />
              <Route path="user/delete" Component={GuideUserDelete} />
              <Route path="user/role" Component={GuideUserRole} />
              <Route path="user/search" Component={GuideUserSearch} />
              {/* 通知管理 */}
              <Route path="notice/overview" Component={GuideNoticeOverview} />
              <Route path="notice/create-notice" Component={GuideNoticeCreateNotice} />
              <Route path="notice/create-info" Component={GuideNoticeCreateInfo} />
              <Route path="notice/admin-manage" Component={GuideNoticeAdminManage} />
              <Route path="notice/user" Component={GuideNoticeUser} />
              {/* 年度管理 */}
              <Route path="financial-year/overview" Component={GuideFinancialYearOverview} />
              <Route path="financial-year/register" Component={GuideFinancialYear} />
              {/* パートナー管理 */}
              <Route path="partner/overview" Component={GuidePartnerOverview} />
              <Route path="partner/register" Component={GuidePartnerRegister} />
              <Route path="partner/update" Component={GuidePartnerUpdate} />
              <Route path="partner/detail" Component={GuidePartnerDetail} />
              <Route path="partner/search" Component={GuidePartnerSearch} />
              <Route path="partner/bulk-register" Component={GuidePartnerBulkRegister} />
              {/* 取引先管理 */}
              <Route path="client/overview" Component={GuideClientOverview} />
              <Route path="client/register" Component={GuideClientRegister} />
              <Route path="client/update" Component={GuideClientUpdate} />
              <Route path="client/detail" Component={GuideClientDetail} />
              <Route path="client/search" Component={GuideClientSearch} />
              <Route path="client/bulk-register" Component={GuideClientBulkRegister} />
              {/* プロジェクト管理 */}
              <Route path="project/overview" Component={GuideProjectOverview} />
              <Route path="project/register" Component={GuideProjectRegister} />
              <Route path="project/update" Component={GuideProjectUpdate} />
              <Route path="project/detail" Component={GuideProjectDetail} />
              <Route path="project/search" Component={GuideProjectSearch} />
              <Route path="project/bulk-register" Component={GuideProjectBulkRegister} />
              {/* 要員管理 */}
              <Route path="member/overview" Component={GuideMemberOverview} />
              <Route path="member/register-employee" Component={GuideMemberRegisterEmployee} />
              <Route path="member/register-external" Component={GuideMemberRegisterExternal} />
              <Route path="member/bulk-register" Component={GuideMemberBulkRegister} />
              <Route path="member/update" Component={GuideMemberUpdate} />
              <Route path="member/delete" Component={GuideMemberDelete} />
              <Route path="member/search" Component={GuideMemberSearch} />
              <Route path="member/detail" Component={GuideMemberDetail} />
              {/* 契約管理 */}
              <Route path="contract/overview" Component={GuideContractOverview} />
              <Route path="contract/new-request" Component={GuideContractNewRequest} />
              <Route path="contract/change-terminate" Component={GuideContractChangeTerminate} />
              <Route path="contract/request-manage" Component={GuideContractRequestManage} />
              <Route path="contract/comment" Component={GuideContractComment} />
              <Route path="contract/search" Component={GuideContractSearch} />
              <Route path="contract/checklist" Component={GuideContractChecklist} />
              <Route path="contract/template" Component={GuideContractTemplate} />
              <Route path="contract/duplicate" Component={GuideContractDuplicate} />
              <Route path="contract/paste" Component={GuideContractPastePage} />
              {/* 資産管理 */}
              <Route path="assessment/overview" Component={GuideAssessmentOverview} />
              <Route path="assessment/register" Component={GuideAssessmentRegister} />
              <Route path="assessment/update" Component={GuideAssessmentUpdate} />
              <Route path="assessment/dispose" Component={GuideAssessmentDispose} />
              <Route path="assessment/detail" Component={GuideAssessmentDetail} />
              <Route path="assessment/search" Component={GuideAssessmentSearch} />
              <Route path="assessment/bulk-register" Component={GuideAssessmentBulkRegister} />
              {/* セキュリティチェック */}
              <Route path="security/overview" Component={GuideSecurityOverview} />
              <Route path="security/admin-start" Component={GuideSecurityAdmin} />
              <Route path="security/user-execute" Component={GuideSecurityUser} />
              {/* 共通機能 */}
              <Route path="common/overview" Component={GuideCommonOverview} />
              <Route path="common/search-condition" Component={GuideSearchCondition} />
              <Route path="common/feedback" Component={GuideFeedback} />
              {/* デプロイ（DEVELOPER限定） */}
              <Route path="deploy/overview" Component={GuideDeployOverview} />
              <Route path="deploy/frontend" Component={GuideFrontendDeploy} />
              <Route path="deploy/backend" Component={GuideBackendDeploy} />
              <Route path="deploy/db-access" Component={GuideDeveloperDbAccess} />
              {/* 研修 */}
              <Route path="training/overview" Component={GuideTrainingOverview} />
              <Route path="training/workspace" Component={GuideTrainingWorkspace} />
              <Route path="training/execute" Component={GuideTrainingExecute} />
              <Route path="training/admin" Component={GuideTrainingAdmin} />
              <Route path="*" Component={NotFound} />
            </Route>
            <Route path="workspace" element={<AuthenticatedLayoutRoute layout={WorkspaceLayout} />}>
              <Route index Component={WorkspacePage} />
              <Route path=":userId" Component={WorkspacePage} />
              <Route path="knz-reference" Component={KnzReference} />
              <Route path="*" Component={NotFound} />
            </Route>
            {/* 研修管理（DEVELOPER のみ） */}
            <Route
              path="training-admin"
              element={<AuthenticatedLayoutRoute layout={TrainingAdminLayout} />}
            >
              <Route index Component={TrainingAdminHome} />
              <Route path="training-assignment" Component={TrainingAdminAssignmentManagement} />
              <Route path="training-question" Component={TrainingAdminQuestionManagement} />
              <Route path="training-progress" Component={TrainingAdminProgressDashboard} />
              <Route path="*" Component={NotFound} />
            </Route>
            {/* 研修受講（全ユーザー） */}
            <Route
              path="training-learn"
              element={<AuthenticatedLayoutRoute layout={TrainingLearnLayout} />}
            >
              <Route index Component={TrainingLearnHome} />
              <Route path="learn-assignment" Component={TrainingLearnAssignmentList} />
              <Route path="all-questions" Component={TrainingLearnAllQuestions} />
              <Route path="learn-assignment/:assignmentId" Component={TrainingLearnQuestionList} />
              <Route
                path="learn-assignment/:assignmentId/question/:questionId"
                Component={TrainingLearnQuestionDetail}
              />
              <Route path="*" Component={NotFound} />
            </Route>
            {/* チケット管理（サイドバー非表示ドメイン・全ユーザー） */}
            <Route path="ticket" element={<AuthenticatedLayoutRoute layout={TicketLayout} />}>
              <Route index Component={TicketHome} />
              <Route path="ticket-list" Component={TicketList} />
              <Route path="board" Component={TicketBoard} />
              <Route path="gantt" Component={TicketGantt} />
              <Route path="type/global" Component={GlobalTicketTypeSettings} />
              <Route path="type/private" Component={PrivateTicketTypeSettings} />
              <Route path=":ticketId" Component={TicketList} />
              <Route path="*" Component={NotFound} />
            </Route>
          </Route>
          {/* DevInsights（記事）はゲスト閲覧を許容するため、認証必須の / とは別に OptionalAuth 配下に置く */}
          <Route path="/devdocs" element={<OptionalAuthLayoutRoute layout={DevDocsLayout} />}>
            <Route index Component={DevDocsHome} />
            {/* 記事（ゲスト閲覧可 / 登録・編集はログイン必須。フォーム側でガード） */}
            <Route path="article/create" Component={ArticleForm} />
            <Route path="article/:articleId" Component={ArticleDetail} />
            <Route path="article/:articleId/edit" Component={ArticleForm} />
            <Route path="thoughts-ai" Component={ThoughtsAi} />
            <Route path="productivity-analysis" Component={ProductivityAnalysis} />
            {/* ワークフローガイド */}
            <Route path="workflow" Component={WorkflowHome} />
            <Route path="workflow/kiro-basics-1" Component={WorkflowKiroBasics1} />
            <Route path="workflow/kiro-basics-2" Component={WorkflowKiroBasics2} />
            <Route path="workflow/kiro-basics-3" Component={WorkflowKiroBasics3} />
            <Route path="workflow/kiro-basics-4" Component={WorkflowKiroBasics4} />
            <Route path="workflow/req-step1" Component={WorkflowReqStep1} />
            <Route path="workflow/req-step2" Component={WorkflowReqStep2} />
            <Route path="workflow/req-step3" Component={WorkflowReqStep3} />
            <Route path="workflow/req-step4" Component={WorkflowReqStep4} />
            <Route path="workflow/be-step1" Component={WorkflowBeStep1} />
            <Route path="workflow/be-step2" Component={WorkflowBeStep2} />
            <Route path="workflow/be-step3" Component={WorkflowBeStep3} />
            <Route path="workflow/be-step4" Component={WorkflowBeStep4} />
            <Route path="workflow/be-step5" Component={WorkflowBeStep5} />
            <Route path="workflow/be-step6" Component={WorkflowBeStep6} />
            <Route path="workflow/be-appendix" Component={WorkflowBeAppendix} />
            {/* ハンズオンガイド */}
            <Route path="handson" Component={HandsonHome} />
            <Route path="handson/preparation" Component={HandsonPreparation} />
            <Route path="handson/story-scaffold" Component={HandsonStoryScaffold} />
            <Route path="handson/steering-rules" Component={HandsonSteeringRules} />
            <Route path="handson/rfp" Component={HandsonRfp} />
            <Route path="handson/proposal-business" Component={HandsonProposalBusiness} />
            <Route path="handson/usecase" Component={HandsonUsecase} />
            <Route path="handson/product" Component={HandsonProduct} />
            <Route path="handson/structure-tech" Component={HandsonStructureTech} />
            <Route path="handson/schema-api" Component={HandsonSchemaApi} />
            <Route path="handson/api-workflow" Component={HandsonApiWorkflow} />
            <Route path="handson/e2e" Component={HandsonE2e} />
            <Route path="handson/project-setup" Component={HandsonProjectSetup} />
            <Route path="handson/api-specs" Component={HandsonApiSpecs} />
            <Route path="handson/screen-io" Component={HandsonScreenIo} />
            <Route path="handson/implementation" Component={HandsonImplementation} />
            <Route path="*" Component={NotFound} />
          </Route>
          <Route path="*" Component={NotFound} />
        </Routes>
      </BrowserRouter>
      <ToastContainer
        position="bottom-left"
        autoClose={2000}
        hideProgressBar
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable={false}
        pauseOnHover
        icon={false}
        closeButton={false}
        transition={Slide}
        toastStyle={{
          background: 'transparent',
          boxShadow: 'none',
          padding: 0,
          margin: 0,
          minHeight: 'auto',
        }}
        style={{ zIndex: 9999, left: 16, bottom: 16, width: 480 }}
      />
    </LocalizationProvider>
  );
}

export default App;
